var $862832bdcbb90256$exports = {};
$862832bdcbb90256$exports = {
  "alert": `Uyar\u{131}`,
  "dismiss": `Kapat`
};
export { $862832bdcbb90256$exports as default };